export const sucessErrorMsg = {
  companySucessMsg: 'sucess fecting Company details',
  companyErrorMsg: 'error fetching Company details',
  recordingUnavailableMsg:
    'Recording facility unavailable. You can still continue with the call.',
  meetingLinkErrorMsg: 'Failed to start meeting.',
  tokenFetchError: 'Failed to fetch token',
  noKeyReturned: 'Failed to fetch Jitsi token: No key returned',
}

export const lmsIntent = {
  getOrderInvoices: 'getOrderInvoices',
  createOrderEvent: 'createOrderEvent',
  getTestPriceFromOdoo: 'getTestPriceFromOdoo',
  updateLabOrderInvoice: 'updateLabOrderInvoice',
  createLabInvoice: 'createLabInvoice',
  getAllPanelsApi: 'getAllPanelsApi',
  CancelLabOrder: 'CancelLabOrder',
  getAllPriceList: 'getAllPriceList',
}

export const constants = {
  joinMeeting: 'Join Meeting',
}

export const JITSI_SECRET_KEY = process.env.REACT_APP_JITSI_SECRET_KEY
